import { render, staticRenderFns } from "./groupCard.vue?vue&type=template&id=1d52499f&scoped=true&"
import script from "./groupCard.vue?vue&type=script&lang=js&"
export * from "./groupCard.vue?vue&type=script&lang=js&"
import style0 from "./groupCard.vue?vue&type=style&index=0&id=1d52499f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d52499f",
  null
  
)

export default component.exports